// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import { useTranslation } from 'react-i18next'

import { Typography } from '../../components'
import { isV2 } from '../../utils/feature-flag-utils'

const GuidedWorkspaceData = () => {
  const { t } = useTranslation(['dashboard'])

  const content = (text = '') => {
    return (
      <Typography type="paragraph" size="small">
        {text}
      </Typography>
    )
  }
  const leftAlign = 'left'
  const data = {
    '/home/get-started': [],
    '/manage-account/identity/users': [
      {
        slot: 'users-card',
        target: isV2() ? 'add-users-btn-box' : 'invite-users-btn-box',
        align: 'bottomRight',
        header: isV2()
          ? t('dashboard:guided_workspace.add_users_title')
          : t('dashboard:guided_workspace.manage_users_card_title'),
        content: content(t('dashboard:guided_workspace.manage_users_card_text'))
      }
    ],
    '/services/service-catalog': [
      {
        slot: 'services-card',
        target: 'service-centric-menulist-service-catalog-link',
        align: 'right',
        header: t('dashboard:guided_workspace.services_card_title'),
        content: content(t('dashboard:guided_workspace.services_card_text'))
      }
    ],
    '/services/service-subscriptions': [
      {
        slot: 'service-subs-card',
        target: 'no-data-info-service-subscriptions-box',
        align: leftAlign,
        header: t('dashboard:guided_workspace.service_subs_card_title'),
        content: content(t('dashboard:guided_workspace.service_subs_card_text'))
      }
    ],
    '/devices/subscriptions-list': [
      {
        slot: 'subscriptions-card',
        target: 'no-data-info-licenses-box',
        align: leftAlign,
        header: t('dashboard:guided_workspace.device_subs_card_title'),
        content: content(t('dashboard:guided_workspace.device_subs_card_text'))
      }
    ],
    '/devices/inventory-list': [
      {
        slot: 'devices-card',
        target: 'no-data-info-devices-box',
        align: leftAlign,
        header: t('dashboard:guided_workspace.add_devices_card_title'),
        content: content(t('dashboard:guided_workspace.add_devices_card_text'))
      }
    ]
  }

  return data
}

export { GuidedWorkspaceData }
